import { computed, onBeforeUnmount, shallowRef, watch } from 'vue';
import raf from '../../../_util/raf';
export default function useIndicator(options) {
    const { activeTabOffset, horizontal, rtl, indicator } = options;
    const inkStyle = shallowRef();
    let inkBarRafRef;
    const cleanInkBarRaf = () => {
        raf.cancel(inkBarRafRef);
    };
    const getLength = (origin) => {
        var _a;
        const size = (_a = indicator === null || indicator === void 0 ? void 0 : indicator.value) === null || _a === void 0 ? void 0 : _a.size;
        if (typeof size === 'function') {
            return size(origin);
        }
        if (typeof size === 'number') {
            return size;
        }
        return origin;
    };
    watch([activeTabOffset, horizontal, rtl, () => { var _a; return (_a = indicator === null || indicator === void 0 ? void 0 : indicator.value) === null || _a === void 0 ? void 0 : _a.size; }, () => { var _a; return (_a = indicator === null || indicator === void 0 ? void 0 : indicator.value) === null || _a === void 0 ? void 0 : _a.align; }], () => {
        var _a, _b;
        const newInkStyle = {};
        const offset = activeTabOffset.value;
        const align = (_b = (_a = indicator === null || indicator === void 0 ? void 0 : indicator.value) === null || _a === void 0 ? void 0 : _a.align) !== null && _b !== void 0 ? _b : 'center';
        if (offset) {
            if (horizontal.value) {
                newInkStyle.width = getLength(offset.width);
                const key = rtl.value ? 'right' : 'left';
                if (align === 'start') {
                    newInkStyle[key] = offset[key];
                }
                else if (align === 'center') {
                    newInkStyle[key] = offset[key] + offset.width / 2;
                    newInkStyle.transform = rtl.value ? 'translateX(50%)' : 'translateX(-50%)';
                }
                else if (align === 'end') {
                    newInkStyle[key] = offset[key] + offset.width;
                    newInkStyle.transform = 'translateX(-100%)';
                }
            }
            else {
                newInkStyle.height = getLength(offset.height);
                if (align === 'start') {
                    newInkStyle.top = offset.top;
                }
                else if (align === 'center') {
                    newInkStyle.top = offset.top + offset.height / 2;
                    newInkStyle.transform = 'translateY(-50%)';
                }
                else if (align === 'end') {
                    newInkStyle.top = offset.top + offset.height;
                    newInkStyle.transform = 'translateY(-100%)';
                }
            }
        }
        cleanInkBarRaf();
        inkBarRafRef = raf(() => {
            inkStyle.value = newInkStyle;
        });
    }, { flush: 'post', immediate: true });
    onBeforeUnmount(() => {
        cleanInkBarRaf();
    });
    return { style: computed(() => inkStyle.value) };
}
